import React from 'react';
import { Modal } from '@mui/material';
import { useStyles } from './CartNotLoadedModal.style';
import { BodyText, BodyL, H3, H2 } from '@lognex/ui-typography';
import { Button } from '@components/shared/Button/Button.component';
import { motion } from 'framer-motion/dist/framer-motion';
import { useIsMobile } from '@hooks/useIsMobile';
import { Localizator } from '@utils/Localizator';

interface Props {
  isOpened: boolean;
  onRepeat: () => void;
  onCreateNew: () => void;
}
export const CartNotLoadedModal = ({
  isOpened,
  onCreateNew,
  onRepeat,
}: Props) => {
  const { classes } = useStyles();
  const { isMobile } = useIsMobile();
  const { t } = Localizator.translate();

  const tTitle = t('CartErrorLoading.Title');
  const tText = t('CartErrorLoading.Text');

  return (
    <Modal
      open={isOpened}
      componentsProps={{ backdrop: { className: classes.backdrop } }}
    >
      <motion.div
        className={classes.box}
        initial={{
          translateY: '100%',
        }}
        animate={{
          translateY: '0%',
        }}
        transition={{
          bounce: 0,
        }}
      >
        {isMobile && <div className={classes.grip} />}
        {isMobile ? (
          <H3 className={classes.title}>{tTitle}</H3>
        ) : (
          <H2 className={classes.title}>{tTitle}</H2>
        )}
        {isMobile ? (
          <BodyL className={classes.text}>{tText}</BodyL>
        ) : (
          <BodyText className={classes.text}>{tText}</BodyText>
        )}
        <div className={classes.buttons}>
          <Button
            testId="create-new-cart-button"
            variant="secondary"
            className={classes.button}
            onClick={onCreateNew}
          >
            {t('CartErrorLoading.CreateNew')}
          </Button>
          <Button
            testId="repeat-load-button"
            className={classes.button}
            onClick={onRepeat}
          >
            {t('CartErrorLoading.Repeat')}
          </Button>
        </div>
      </motion.div>
    </Modal>
  );
};
